$(function () {
    $(document).ready(function () {
        var searchBar = $('.search-bar');

        $(document).on('click', '.fa-magnifying-glass', function () {

            if ($(this).hasClass("clicked")) {
                searchBar.slideUp();
            }
            else {
                searchBar.slideDown();
            }

            $(this).toggleClass("clicked");
        });

        $('#searchForm').submit(function (e) {
            e.preventDefault();

            // already on one of the search landing pages
            if ($(this).find('#searchFilter').val() == window.location.pathname) {

                var currentUrl = window.location.href;
                var currentParamArr = currentUrl.split('?');
                var currentParams = currentParamArr.reverse()[0];
                var params = currentParams.split('&').filter(x => x.length > 0);
                var currentSS = 'ss=' + $(this).find('#searchInput').val();
                var otherParams = params.filter(x => !x.includes('ss=')).join('&');

                if (otherParams == '') {
                    currentSS = '?' + currentSS;
                }
                else {
                    otherParams = '?' + otherParams;
                    currentSS = '&' + currentSS;
                }

                var newUrl = currentParamArr.find(x => x.includes('http')) + otherParams + currentSS;
                window.location.href = newUrl;
            }
            else {
                // need to redirect to the selected search landing page
                window.location.href = $(this).find('#searchFilter').val() + '?ss=' + $(this).find('#searchInput').val();
            }

        });
    });
});